export function isHeic(file) {
  if (file.type === "image/heic" || file.type === "image/heif") return true
  if (/\.hei[cf]$/i.test(file.name)) return true
  return false
}

export async function convertHeicToJpeg(file) {
  const formData = new FormData()
  formData.append("image", file)

  const token = document.querySelector("meta[name='csrf-token']")?.content
  const response = await fetch("/recipe_imports/preview", {
    method: "POST",
    headers: { "X-CSRF-Token": token },
    body: formData
  })

  if (!response.ok) throw new Error("Server conversion failed")

  const { preview_url } = await response.json()
  const imgResponse = await fetch(preview_url)
  const blob = await imgResponse.blob()
  const name = file.name.replace(/\.hei[cf]$/i, ".jpg")
  return new File([blob], name, { type: "image/jpeg" })
}
